import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

export const EstatePackageCreationListing = ({ estatePackageCreationData, handleClick, hasEdit }) => {
    
    const [estatePackageCreation, setPackageCreation] = useState([]);

    const contentRowNames = ["collectionPointName","packageCode", "packageName","userName", "cardNumber", "isActive"]

    useEffect(() => {
        trackPromise(
            setPackageCreationData()
            )
    }, [estatePackageCreationData]);

    async function setPackageCreationData() {
        destroyDataTable();
        await setPackageCreation(estatePackageCreationData);
        createDataTable();
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>):
             <td key={index}>{da[row] + " "}</td>
            )
         )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                <div className="card">
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Division</th>
                                        <th>Package Code</th>
                                        <th>Package Name</th>
                                        <th>User Name</th>
                                        <th>Card Number</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {estatePackageCreation.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                {content(data)}
                                                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(data)} style={{cursor: "pointer"}}><i class="far fa-edit"></i></td> : null}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                </div>
            </div>
        </div>
    </Fragment>
    )

}